const deepFooterMenu = document.querySelector('.deep-footer-menu');
const isBrainHealthSite = document.querySelector('body.site-10');
if (deepFooterMenu) {
	deepFooterMenu.classList.add(`has-${deepFooterMenu.childElementCount}-items`);
}

if (deepFooterMenu && isBrainHealthSite) {
	if (window.screen.width > 767) {
		const fauxTopLevelMenu = deepFooterMenu.querySelectorAll('.top-level-menu-item');
		const thirdFooterMenu = deepFooterMenu.children[2].querySelector('.sub-menu');

		deepFooterMenu.classList.remove(`has-${deepFooterMenu.childElementCount}-items`);
		deepFooterMenu.classList.add('has-5-items');

		fauxTopLevelMenu.forEach((item) => {
			thirdFooterMenu.appendChild(item);
		});
	}
}
